import { StarsButton } from '@ps/web-shared-components';
import React from 'react';
import { useRouteMatch } from 'react-router';

import { useGetCurrentClub } from '@swf/poker';

import type { UserClubRole } from '../../../../types/common';
import useCloseOrLeaveClub from '../hooks/useCloseOrLeaveClub';
import { row } from '../shared.scss';

import { TXTWCL_Leave_Club } from './CloseOrLeaveClub.messages.json';

const CloseOrLeaveClub: React.FC = () => {
  const {
    params: { clubId }
  } = useRouteMatch<{ clubId: string }>();
  const club = useGetCurrentClub(clubId);
  const roleForUser = club?.roleForUser;
  const { action, loading: leaveClubLoading } = useCloseOrLeaveClub();

  return (
    <div className={row}>
      <StarsButton
        disabled={leaveClubLoading}
        variant="primary"
        translation={TXTWCL_Leave_Club}
        onClick={() => action(roleForUser as UserClubRole)}
      />
    </div>
  );
};

export default CloseOrLeaveClub;
